<!-- <section id="productsListFullWidth">
  <div class="container-fluid">
    <h2 class="subTitleColor">Related Products</h2>
    <span *ngFor="let item of relatedProducts">
      <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()" [scrollWindow]="true">
        <app-product-card (selectedProduct)="selectProduct($event)" [item]="item"></app-product-card>
      </div>
    </span>
    <div class="clearfix"></div>
  </div>
</section> -->

<section>
  <div class="container-fluid">
    <div class="row">
      <main class="productsList col-md-8 col-lg-9">
      <mat-tab-group > 
          <mat-tab label="{{translation['Related Products']}}">
            <span *ngFor="let item of relatedProducts">
              <div class="search-results">
                <app-product-card [item]="item"></app-product-card>
              </div>
            </span>  
         </mat-tab>	      
        </mat-tab-group>
      </main>
    </div>
  </div> 
  </section>
